import React from 'react';
import Award from './Award';
import '../../CommonCSS/SocietyCSS.css'


const AwardApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Awards and Certificate</h5>
          </div>  
        </div>
        <Award/>
      </div>
    </div >
  );
};

export default AwardApp;
